import * as t from 'ts-codec';
import { ObjectId } from '@journeyapps-labs/micro-codecs';
import { GroupProfileRole, GroupUser, GroupUserStatus, PackResource } from '../types/types-groups.js';
import { PaginatedRequest, PaginatedResponse } from './pagination.js';
export var ApiPackRoutes;
(function (ApiPackRoutes) {
    ApiPackRoutes["GET_MY_PACK_STATUS"] = "/api/v1/packs/get-my-status";
    ApiPackRoutes["GET_PACK"] = "/api/v1/packs/get";
    ApiPackRoutes["GET_PACKS"] = "/api/v1/packs/get-all";
    ApiPackRoutes["GET_PACK_MEMBERS"] = "/api/v1/packs/get-pack-members";
    ApiPackRoutes["CREATE_PACK"] = "/api/v1/packs/create";
    ApiPackRoutes["REQUEST_TO_JOIN_PACK"] = "/api/v1/packs/request-to-join";
    ApiPackRoutes["REVOKE_REQUEST_TO_JOIN"] = "/api/v1/packs/revoke-request-to-join";
    ApiPackRoutes["INVITE_PACK_MEMBER"] = "/api/v1/packs/invite-send";
    ApiPackRoutes["ACCEPT_PACK_INVITE"] = "/api/v1/packs/invite-accept";
    ApiPackRoutes["LEAVE_PACK"] = "/api/v1/packs/leave-pack";
    ApiPackRoutes["ACCEPT_REQUEST_TO_JOIN"] = "/api/v1/packs/accept-request-to-join";
})(ApiPackRoutes || (ApiPackRoutes = {}));
export const InvitePackMemberRequest = t.object({
    pack_id: ObjectId,
    user_id: ObjectId,
    role: t.Enum(GroupProfileRole)
});
export const GetPackMembersRequest = PaginatedRequest.and(t.object({
    group_id: ObjectId
}));
export const GetPackMembersResponse = PaginatedResponse(GroupUser);
export const GetPacksRequest = PaginatedRequest.and(t.object({
    search: t.string.optional()
}));
export const PacksResponse = PaginatedResponse(PackResource);
export const ProfileGroupStatus = t.object({
    role: t.Enum(GroupProfileRole),
    status: t.Enum(GroupUserStatus)
});
